<script>
import { mapGetters, mapActions } from 'vuex';
import Loader from '@/components/Common/Loader';

export default {
  name: 'JustLoader',
  components: {
    Loader,
  },
  computed: {
    ...mapGetters({
      allShowedOverlays: 'Popups/allShowedOverlays',
    }),

    isShowedPopup() {
      return this.allShowedOverlays?.includes('just-loader');
    },
  },

  methods: {
    ...mapActions({
      togglePopup: 'Popups/togglePopup',
    }),

    closePopup() {
      this.togglePopup('just-loader');
    },
  },
};
</script>

<template>
  <div
    class="popup-new"
    :class="{ 'opacity-100 visible': isShowedPopup }"
    @click.self="closePopup"
  >
    <div class="popup-new-inner">
      <div class="w-full">
        <div class="flex items-center justify-between mb-2.5 md:mb-5">
          <img src="/public/images/logo.svg" alt="" class="w-full max-w-[186px] h-[41px] pr-2">
          <div
            class="popup-new__close"
            @click="closePopup"
          ></div>
        </div>
        <div class="relative h-20">
          <loader />
        </div>
      </div>
    </div>
  </div>
</template>